<template>
  <main class="main-content-area" v-observer="mutationObserve">
    <template v-if="pageBlockData1 && pageBlockData1.length > 0">
      <template v-for="(data, index) in pageBlockData1">
        <CustomComponent :key="`${data.blockName}-${index}`" 
          :pageValue="'home'"
          :blockData="data" 
          :recommendSection="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? recommend_section : {}"
          :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
          :blockIndex="index"
          />
      </template>
    </template>

    <template v-if="pageBlockData2 && pageBlockData2.length > 0">
      <template v-for="(data, index) in pageBlockData2">
        <CustomComponent :key="`${data.blockName}-${index}`" 
          :pageValue="'home'"
          :blockData="data" 
          :recommendSection="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? recommend_section : {}"
          :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
          :blockIndex="index"
          />
      </template>
      <!--Author Block-->
      <template
        v-if="auhtorBlockdata && pageBlockData2.length === blockData2.length"
      >

      </template>
      <!--End Author Block-->
    </template>
  </main>
</template>

<script>
import CustomComponent from '@/components/CustomComponent';
import router from "@/router";
import { pSBC, getOffset } from "@/misc/misc-function";
import { metaChanger } from "@/misc/meta-changer";

export default {
  name: "Home",
  props: ["homeLayout1Data"],
  data: function () {
    return {
      blockData1: [],
      blockData2: [],
      bluebar: {},
      recommend_section: {},
      content_after_top_games: "",
      content_after_best_payment_methods: {},
      card_testimonials: {},
      assets_images: {},
      isPreview: false,
      // Variables for infinite scroll
      pageBlockData1: [],
      pageBlockData2: [],
      block1Index: 0,
      block2Index: 0,
      card_testimonials_columns: "",
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      busy: false,
      scriptFlag: 0,
      showDesHom: false,
      auhtorBlockdata: [],
      rightBlockdata: [],
    };
  },
  components: {
   CustomComponent,
  },
  methods: {
    getOffset,
    pSBC,
    metaChanger,
    pageCountText: function (hideShowCount, count, singularText, pluralText) {
      if (count === 0) {
        return hideShowCount ? "" : `0 ${singularText}`;
      } else if (count > 1) {
        return pluralText != ""
          ? `${count} ${pluralText}`
          : `${count} ${singularText}`;
      } else {
        return `${count} ${singularText}`;
      }
    },
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserve: function (mutations) {
      if (this.pageBlockData1.length < this.blockData1.length) {
        let mainContentArea =
          this.getOffset(mutations[0].target).top +
          mutations[0].target.offsetHeight;
        if (mainContentArea < window.innerHeight) {
          this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
          this.block1Index++;
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (
        this.pageBlockData1.length < this.blockData1.length ||
        this.pageBlockData2.length < this.blockData2.length
      ) {
        this.busy = true;
        if (this.pageBlockData1.length < this.blockData1.length) {
          this.pageBlockData1 = this.blockData1.slice(0, this.block1Index + 1);
          this.block1Index++;
        } else {
          this.pageBlockData2 = this.blockData2.slice(0, this.block2Index + 1);
          this.block2Index++;
        }
        //this.heightCheck();
        this.busy = false;
      }
    },
    itemFAQBlue: function (data) {
      let finalData = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        finalData.push({ id, title, content, is_active });
      });
      return finalData;
    },
  },
  // beforeCreate: function () {
  //   this.$root.loading = true;
  // },
  created: function () {
    if (
      this.$root.routes_meta[wpvue_script_data_params.frontpage_slug] &&
      this.$root.routes_meta[wpvue_script_data_params.frontpage_slug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[wpvue_script_data_params.frontpage_slug].metaTags
      );

    if (
      Object.keys(this.$route.query).length > 0 &&
      this.$route.query.preview
    ) {
      if (this.$route.query.page === "home") {
        this.isPreview = true;
      } else {
        router.push({ path: "preview", query: this.$route.query });
      }
    }
  },
  mounted: function () {
    if (this.homeLayout1Data) {
      this.blockData1 = [];
      let block1 = [];
      const data = this.homeLayout1Data;
      const blocks = data.content.blocks;
      const meta = data.meta;
      let toplist = blocks
        .filter(
          (ele) =>
            ele.blockName === "wpvcb/casino-toplist" &&
            (ele.attrs.style === "home_top_3" || !ele.attrs.style)
        )
        .sort((ele) => (ele.attrs.style === "home_top_3" ? -1 : 1));

      block1.push(...toplist);

      let faqBlue = blocks.filter(
        (ele) =>
          ele.blockName === "wpvcb/faq" &&
          ele.attrs &&
          ele.attrs.style === "blue_bg"
      );

      let reqArray = [
        "wpvcb/home-promote-banner",
        "wpvcb/best-payment-methods",
        "wpvcb/game-guide-categories",
        "wpvcb/top-games",
        "wpvcb/top-games-articles",
      ];

      reqArray.forEach((item) => {
        let tempBlock = blocks.filter((ele) => ele.blockName === item);
        if (tempBlock.length > 0) {
          block1.push(tempBlock.shift());
        }
      });

      this.blockData1 = block1;

      let topGamesLoc = this.blockData1
        .map((ele, index) =>
          ele.blockName === "wpvcb/top-games" ? index : null
        )
        .filter((val) => val != null)
        .shift();
      let topArtLoc = this.blockData1
        .map((ele, index) =>
          ele.blockName === "wpvcb/top-games-articles" ? index : null
        )
        .filter((val) => val != null)
        .shift();

      if (faqBlue.length > 0) {
        if (topGamesLoc) {
          block1.splice(topGamesLoc + 1, 0, ...faqBlue);
        } else if (topArtLoc) {
          block1.splice(topArtLoc, 0, ...faqBlue);
        } else {
          block1.push(...faqBlue);
        }
      }

      let block2 = blocks.filter(
        (ele) =>
          reqArray.indexOf(ele.blockName) === -1 &&
          ["wpvcb/casino-toplist", "wpvcb/faq", null].indexOf(ele.blockName) ===
            -1
      );

      let otherToplist = blocks.filter(
        (ele) =>
          (ele.blockName === "wpvcb/casino-toplist" &&
            ele.attrs.style &&
            ele.attrs.style != "home_top_3") ||
          (ele.blockName === "wpvcb/faq" && !ele.attrs.hasOwnProperty("style"))
      );

      this.blockData2 = [...block2, ...otherToplist];

      if (meta.bluebar) {
        this.bluebar = meta.bluebar;
      } else {
        this.bluebar = {};
      }

      if (meta.card_testimonials) {
        this.card_testimonials = meta.card_testimonials;
        this.card_testimonials_columns = meta.card_testimonials_columns;
      } else {
        this.card_testimonials = [];
        this.card_testimonials_columns = "";
      }

      if (meta.content_after_best_payment_methods) {
        this.content_after_best_payment_methods =
          meta.content_after_best_payment_methods;
      } else {
        this.content_after_best_payment_methods = {};
      }

      if (meta.content_after_top_games) {
        this.content_after_top_games = meta.content_after_top_games;
      } else {
        this.content_after_top_games = "";
      }

      if (meta.recommend_section) {
        this.recommend_section = meta.recommend_section;
      } else {
        this.recommend_section = {};
      }

      document.getElementById("schema-script").innerHTML = data.schema;

      // Author Blocks Filtered
      let atBlock = blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/author-block") {
          return ele.filtered_content;
        }
      });
      if (atBlock.length > 0)
        this.auhtorBlockdata = atBlock.shift().filtered_content;

      // RightContent Blocks Filtered
      let rightBlock = blocks.filter((ele) => {
        if (ele.blockName === "wpvcb/right-content-simpletoc") {
          return ele.filtered_content;
        }
      });
      if (rightBlock.length > 0)
        this.rightBlockdata = rightBlock.shift().filtered_content;

      // Adminbar Data
      this.$root.adminBarData =
        Object.keys(data.toolbar).length > 0 ? data.toolbar : "";
      this.$root.disable = this.$root.adminBarData
        ? this.$root.adminBarData.visible
        : false;

      // Assets Sizes
      this.assets_images =
        Object.keys(this.$root.asset_sizes).length > 0
          ? this.$root.asset_sizes
          : "";

      // if (this.$root.enable_lazyload) {
      //   this.pageBlockData1.push(this.blockData1[this.block1Index]);
      //   this.block1Index++;
      //   this.$root.show_footer = false;
      // } else {
      this.pageBlockData1 = this.blockData1;
      this.pageBlockData2 = this.blockData2;

      this.$root.show_footer = true;
      //}

      if (
        this.scriptFlag === 0 &&
        blocks.filter((ele) => {
          return (
            ele.blockName === "wpvcb/custom-youtube" ||
            ele.blockName === "wpvcb/youtube-film-strip"
          );
        }).length > 0
      ) {
        this.youtubeInit();
        this.scriptFlag++;
      }
      //this.$root.loading = false;
      this.$nextTick(() => this.heightCheck());
      var that = this;
      window.addEventListener(
        "scroll",
        () => {
          that.heightCheck();
        },
        { passive: true }
      );
      window.addEventListener("resize", () => {
        that.heightCheck();
      });
    }
    if (window.innerWidth > 576) {
      this.showDesHom = true;
    } else {
      this.showDesHom = false;
    }
  },
  beforeDestroy: function () {
    this.blockData1 = [];
    this.blockData2 = [];
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.removeEventListener("resize", () => {
      that.heightCheck();
    });
  },
  watch: {
    pageBlockData1: function () {
      if (
        this.pageBlockData1.length === this.blockData1.length &&
        this.pageBlockData2.length === this.blockData2.length
      ) {
        this.$root.show_footer = true;
      }
    },
    pageBlockData2: function () {
      if (
        this.pageBlockData1.length === this.blockData1.length &&
        this.pageBlockData2.length === this.blockData2.length
      ) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.pt-40 {
  padding-top: 40px !important;
}

.sl-4 {
  width: 33.33%;
}

.sl-6 {
  width: 50%;
}

.m-10 {
  margin: 10px 0;
}
.m-20 {
  margin: 20px 0;
}
.p-20 {
  padding: 20px 0;
}
.nopadding {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

//online-casino
.ct-online-casino {
  clear: both;
  display: flex;
  align-items: center;
  width: 100%;
  background: @white;
  padding: 24px 20px 20px;
  margin-top: 0px;
  .border-radius(12px);
  @media (min-width: @sizes[medium]) {
    padding: 25px;
    margin-top: 14px;
  }
  &.add-icon-text-repeater {
    flex-direction: column !important;
  }
  .casino-top {
    display: flex;
  }
  .casino-bottom {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 0.5px solid #dfe1e3;
    margin-top: 15px;
    border-radius: 5px;
    width: 100%;
    @media (min-width: @sizes[large]) {
      flex-direction: row;
    }
    .card-repeater {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-width: 100%;
      border-right: 0;
      border-bottom: 0.5px solid #dfe1e3;
      padding: 5px 10px;
      min-height: 68px;
      @media (min-width: @sizes[large]) {
        min-height: 59px;
        min-width: 290px;
        border-right: 0.5px solid #dfe1e3;
        border-bottom: 0;
      }
      &:last-child {
        border-bottom: 0;
        @media (min-width: @sizes[large]) {
          border-right: 0;
        }
      }
      &-img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-right: 8px;
      }
      &-icon-text {
        margin: 0;
        font-size: 14px;
        text-align: left;
        display: block;
        min-width: 110px;
        margin-right: 8px;
        @media (min-width: @sizes[small]) {
          min-width: 80%;
        }
        @media (min-width: @sizes[large]) {
          min-width: 130px;
        }
      }
      &-text {
        color: #448e47;
        text-align: right;
        width: calc(100% - 110px);
        margin: 0;
        overflow-wrap: anywhere;
        @media (min-width: @sizes[small]) {
          width: 100%;
        }
        @media (min-width: @sizes[large]) {
          width: calc(100% - 130px);
        }
      }
    }
  }
  .casino-left {
    width: 100%;
    @media (min-width: @sizes[medium]) {
      width: calc(85% - 64px);
      margin-right: 64px;
    }
  }
  .casino-right {
    width: 15%;
    display: none;
    @media (min-width: @sizes[medium]) {
      display: block;
    }
    img {
      width: 170px;
      height: 170px;
    }
  }
  .content {
    p {
      color: @lightdark;
    }
  }
}

.ct-card-grp {
  .cta {
    margin-top: 0;
    padding: 15px;
  }
}

.card-flex-row {
  .display-flex;
  align-items: flex-end;
}

.card-sticky {
  padding: 5px 30px;
  background: #ffd039;
  margin: 0 auto;
  text-align: center;
  display: table;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
  font-size: 16px;
  font-weight: 600;
  img {
    margin-right: 8px;
    display: inline-block;
    vertical-align: baseline;
  }
}

.ct-card-horizontal {
  padding: 24px 0;
}
.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
  &-home {
    .display-flex();
    .align-items(center);
    .justify-content-space-between();
    padding: 10px 0;
    .casino-inner {
      color: @white;
      text-align: center;
      //padding: 0px 20px;
      border-right: 1px solid @white;
      -webkit-box-flex: 1;
      -ms-flex: 1 0 0px;
      flex: 1 0 0;
      display: none;
      &:last-child {
        border-right: 0;
        display: block;
      }
      h2 {
        color: @white;
        border-right: 0;
        font-weight: bold;
        padding: 0 8px;
      }
      span {
        color: @white;
        border-right: 0;
        font-weight: bold;
        font-size: 12px;
        line-height: 26px;
        padding: 0 8px;
        @media (min-width: @sizes[small]) {
          font-size: 16px;
          line-height: 160%;
        }
        img {
          width: 18px;
          height: 18px;
        }
      }
      img {
        vertical-align: top;
        margin-right: 8px;
        margin-top: 3px;
      }
      @media (min-width: @sizes[medium]) {
        display: block;
      }
    }
  }
}

.p-20-both {
  padding: 10px 20px;
}

.promotion-bottom-content {
  width: 100%;
  margin-top: 24px;
  @media (min-width: @sizes[large]) {
    width: 82%;
    margin-top: 40px;
  }
  h2 {
    color: @black;
    margin-top: 0px;
    margin-bottom: 13px;
    @media (min-width: @sizes[large]) {
      margin-top: 80px;
      margin-bottom: 25px;
    }
  }
}

.cta-show {
  color: #ebebeb;
  font-size: 16px;
  cursor: pointer;
  border-radius: 0;
  border: none;
  width: auto;
  float: right;
  padding: 0;
  margin: 20px 0;
  text-decoration: underline;
  &:hover {
    color: @white;
    text-decoration: underline;
  }
  &:focus {
    color: @white;
    text-decoration: underline;
  }
  .fa {
    margin-left: 6px;
    font-weight: 600;
  }
}

.promotion-inner {
  position: static;
  width: auto;
  text-align: center;
  @media (min-width: @sizes[large]) {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }
  p {
    white-space: nowrap;
    font-weight: 700;
    margin-bottom: 0;
    margin-top: 25px;
    display: none;
    @media (min-width: @sizes[large]) {
      display: inline-block;
    }
  }
  &-img {
    min-height: auto;
    .display-flex();
    .align-items(center);
    .justify-content-center();
    @media (min-width: @sizes[large]) {
      min-height: 92px;
    }
  }
}

//Selection Holder styles
.selection-holder {
  padding: 19px 0 40px 0;
  @media (min-width: @sizes[large]) {
    padding: 35px 0 70px 0;
  }
  .mobile-scroller {
    .selection-list-box {
      &:last-child {
        @media (max-width: @sizes[small]) {
          margin-right: 22px;
        }
      }
    }
  }
  .container {
    padding-right: 20px;
    @media (min-width: @sizes[medium]) {
      padding: 0 15px;
    }
  }
  .promotion-card {
    background: @white;
    transition: 0.3s all ease;
    -webkit-transition: 0.3s all ease;
    .border-radius(5px);
    h3 {
      margin-bottom: 0;
      padding: 15px;
    }
    &-img {
      border-top-left-radius: 5px;
      border-top-right-radius: 5px;
      height: 200px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &-content {
      padding: 30px;
      .promotion-title {
        a {
          font-size: 16px;
          font-weight: 700;
        }
      }
      p {
        color: @dark-gray;
        margin: 10px 0;
      }
      .game-card-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0 20px 0;
        border-bottom: 1px solid #ebebeb;

        .cta-promotion {
          margin: 0;
          max-width: 155px;
          padding: 15px;
          font-size: 13px;
          -webkit-border-radius: 30px;
          -moz-border-radius: 30px;
          border-radius: 30px;
        }
      }
      .provider-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 15px;
      }
      .selection-icon {
        display: inline-block;
        margin-bottom: 20px;
      }
    }
    &:hover {
      background: #080438;
      transition: 0.3s all ease;
      -webkit-transition: 0.3s all ease;
      .selection-icon svg path {
        color: @white;
      }
    }
  }

  .row .col-md-10 {
    width: 100%;
    padding-right: 28px;
    @media (min-width: @sizes[medium]) {
      padding-right: 0px;
    }
    @media (min-width: @sizes[tablet]) {
      width: 83.33333333%;
    }
  }
}

.selection-listing {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.08);
}

.selection-inner {
  @media (max-width: @sizes[small]) {
    padding-left: 30px !important;
    padding-right: 30px !important;
  }
}

.selection-list {
  .display-flex();
  .flex-wrap(nowrap);
  width: fit-content;
  .border-radius(12px);
  overflow: visible;
  box-shadow: none;
  margin-top: 20px;
  padding-bottom: 13px;
  background: transparent;
  @media (max-width: @sizes[small]) {
    padding-left: 22px;
  }
  @media (min-width: @sizes[medium]) {
    background: @white;
    .flex-wrap(wrap);
    overflow: hidden;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.1);
    padding-bottom: 0;
  }
  &-box {
    min-height: 200px;
    background: @white;
    min-width: 252px;
    overflow: hidden;
    padding: 20px 20px 24px;
    position: relative;
    transition: 0.1s all ease;
    -webkit-transition: 0.1s all ease;
    margin-right: 16px;
    .border-radius(12px);
    white-space: normal;
    @media (min-width: @sizes[medium]) {
      margin: 0;
      .border-radius(0);
      min-width: auto;
      padding: 40px 30px 30px;
    }
    .btm-img {
      position: absolute;
      display: none;
      bottom: -30px;
      right: -30px;
      filter: opacity(0);
      opacity: 0;
      @media (min-width: @sizes[medium]) {
        display: block;
      }
    }
    object {
      margin-bottom: 20px;
      width: 24px;
      height: 24px;
      @media (min-width: @sizes[medium]) {
        margin-bottom: 15px;
        width: 48px;
        height: 48px;
      }
    }
    svg {
      margin-bottom: 20px;
      width: 24px;
      height: 24px;
      @media (min-width: @sizes[medium]) {
        margin-bottom: 15px;
        width: 48px;
        height: 48px;
      }
    }
    p {
      min-height: 110px;
      @media (min-width: @sizes[medium]) {
        min-height: auto;
      }
    }
    a {
      color: var(--primary-btn);
    }
    .read-more {
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
      color: @orange;
      img {
        margin-left: 8px;
      }
      @media (min-width: @sizes[medium]) {
        display: none;
      }
    }

    .testi-card {
      display: block;
    }

    .testi-card-hover {
      display: none;
    }

    &:hover {
      @media (min-width: @sizes[medium]) {
        background-color: var(--primary-btn);
        transition: 0.1s all ease;
        -webkit-transition: 0.1s all ease;
        .btm-img {
          filter: contrast(0.8);
          width: 220px;
          height: auto;
          opacity: 0.2;
        }
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        span {
          color: @white;
        }
        p {
          position: relative;
          color: @white;
          z-index: 1;
          a {
            color: @white;
          }
        }
        li {
          color: @white;
          a {
            color: @white;
          }
        }

        .testi-card {
          display: none;
        }

        .testi-card-hover {
          display: block;
        }
      }
    }
  }
}

.normal-hide {
  display: none;
  margin-bottom: 21px;
}

.normal-show {
  display: block;
  margin-bottom: 21px;
}

.selection-list-box:hover {
  .normal-hide {
    display: block;
  }
  .normal-show {
    display: none;
  }
}

// Top Games bottom list

.ct {
  &-game-guide {
    background-color: @light-gray;
    padding: 32px 0 38px;
    @media (min-width: @sizes[medium]) {
      padding: 60px 0;
    }
    .info-card {
      background-color: @white;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.05);
      .border-radius(12px);
      margin-bottom: 20px;
      @media (min-width: @sizes[medium]) {
        .border-radius(0);
        margin-bottom: 12px;
      }
      .info-card-img {
        width: 100%;
        min-height: 155px;
        cursor: pointer;
        img {
          max-height: 155px;
        }
        @media (min-width: @sizes[medium]) {
          width: 45%;
          min-height: auto;
          img {
            max-height: none;
          }
        }
        @media (min-width: @sizes[large]) {
          width: 30%;
        }
      }
      .info-card-content {
        width: 100%;
        min-height: auto;
        padding: 16px 20px;
        @media (min-width: @sizes[medium]) {
          width: 55%;
          min-height: 110px;
          padding: 45px;
        }
        @media (min-width: @sizes[large]) {
          width: 70%;
        }
        a {
          min-width: 100%;
          margin: 12px auto 0;
          @media (min-width: @sizes[medium]) {
            min-width: 191px;
            margin: 25px auto 0;
          }
        }
        h2 {
          color: @mob-black;
          margin-bottom: 28px;
          @media (min-width: @sizes[medium]) {
            margin: 0 0 16px 0;
            color: @lightdark;
          }
        }
        p {
        }
      }
    }
  }
}

.game-header {
  background: @darkblack;
  padding: 12px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  h2 {
    margin-bottom: 0;
    color: @white;
    padding: 5px;
    text-align: center;
  }
}

.info {
  &-card {
    margin-bottom: 20px;
    .border-radius(3px);
    box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    .display-flex();
    .justify-content-space-between();
    .flex-direction-column();
    &-horizontal {
      .flex-direction-column();
      @media (min-width: @sizes[medium]) {
        .flex-direction-row();
      }
    }
    &-img {
      position: relative;
      width: 30%;
      background-color: @gray;
      img {
        position: relative;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    }
    &-content {
      width: 70%;
      min-height: 110px;
      padding: 45px;
      h2 {
        margin-bottom: 3px;
      }
      h6 {
        margin-bottom: 5px;
      }
      p {
        margin-left: 0;
        margin-bottom: 8px;
        color: @lightdark;
      }
      a {
        box-shadow: inset 0px -4px 4px #d02916;
        min-width: 191px;
        &:hover {
          background-color: @darkred;
          box-shadow: none;
          -webkit-box-shadow: none;
          border-color: @darkred;
          color: @white;
        }
        &:focus {
          background-color: @darkred;
          box-shadow: none;
          -webkit-box-shadow: none;
          border-color: @darkred;
          color: @white;
        }
      }
    }
  }
}

.show-read-more {
  display: none;
  @media (min-width: @sizes[medium]) {
    display: block;
  }
}

.show-read-more-mob {
  display: none;
  @media (max-width: @sizes[small]) {
    display: block;
  }
}

.hidden-methods {
  margin-top: 0px;
  @media (min-width: @sizes[large]) {
    margin-top: 18px;
  }
}

.white-space-nowrap {
  white-space: wrap !important;
  @media (min-width: @sizes[large]) {
    white-space: nowrap !important;
  }
}

.payment-btn {
  @media (min-width: @sizes[large]) {
    min-height: 68px;
    display: flex !important;
    align-items: center !important;
    justify-content: center;
  }
}

.loader-spinner {
  text-align: center;
}

.custom-color {
  a {
    color: var(--primary-btn);
  }
}

.pt-24 {
  padding-top: 24px;
}

.selection-list-box {
  .arrow-left {
    width: 4.5px !important;
    height: 7px !important;
    margin-left: 8px !important;
    margin-bottom: 0px !important;
  }
}

.rm-casino-border {
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
</style>



// WEBPACK FOOTER //
// src/pages/HomeLayout1.vue